import React from "react";
import PropTypes from "prop-types";
import {
  Avatar,
  Box,
  Checkbox,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { formatLinkInstagram } from "../../../../utils/formatLinkInstagram";

const UserRows = ({ rows, isSelected, onRowClick, goToProfile }) => {
  return (
    <TableBody>
      {rows.map((row, index) => {
        const selected = isSelected(row.id);
        const labelId = `enhanced-table-checkbox-${index}`;
        // Helper: true si la mayor fecha `end` es > ahora; false si no hay membresías o todas vencidas
        const isMembershipActiveNow = (memberships) => {
          if (!Array.isArray(memberships) || memberships.length === 0)
            return false;

          const maxEndMs = memberships
            .map((m) => Date.parse(m?.end))
            .filter((ms) => Number.isFinite(ms))
            .reduce((max, ms) => Math.max(max, ms), -Infinity);

          if (!Number.isFinite(maxEndMs)) return false; // no había fechas válidas
          return maxEndMs > Date.now(); // estrictamente mayor a "ahora"
        };

        // Uso en tu fila:
        const hasMembership = isMembershipActiveNow(row?.membership);

        return (
          <TableRow
            hover
            role="checkbox"
            aria-checked={selected}
            tabIndex={-1}
            key={row.id}
            selected={selected}
            sx={{ cursor: "pointer" }}
          >
            <TableCell
              padding="checkbox"
              onClick={(e) => onRowClick(e, row.id)}
            >
              <Checkbox
                color="secondary"
                checked={selected}
                inputProps={{ "aria-labelledby": labelId }}
                sx={{
                  color: "secondary.main",
                  "&.Mui-checked": { color: "secondary.main" },
                }}
              />
            </TableCell>

            <TableCell>
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                <Avatar
                  src={row?.avatar}
                  alt={row?.name}
                  sx={{ width: "100%", height: "100%" }}
                />
              </Box>
            </TableCell>

            <TableCell
              component="th"
              id={labelId}
              scope="row"
              onClick={() => goToProfile(row?.id)}
              sx={{ "&:hover": { textDecoration: "underline" } }}
            >
              <Typography color="text.primary" fontWeight={400}>
                {row?.fullName ||
                  `${row?.name || ""} ${row?.lastname || ""}`.trim()}
              </Typography>
            </TableCell>

            <TableCell>
              <Typography color="text.secondary" fontWeight={400}>
                {row?.email}
              </Typography>
            </TableCell>

            <TableCell align="right">
              <Typography color="text.secondary" fontWeight={400}>
                {row?.alias}
              </Typography>
            </TableCell>

            <TableCell>
              {row?.instagram ? (
                <a
                  href={formatLinkInstagram(row.instagram)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "#D0749B",
                    fontWeight: "bold",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.textDecoration = "underline")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.textDecoration = "none")
                  }
                >
                  <Typography color="text.secondary" fontWeight={400}>
                    {row.instagram.startsWith("@")
                      ? row.instagram.slice(1)
                      : row.instagram}
                  </Typography>
                </a>
              ) : (
                "N/A"
              )}
            </TableCell>

            <TableCell>
              <Typography
                color="text.secondary"
                fontWeight={400}
                component="a"
                href={`https://web.whatsapp.com/send?phone=${row?.phone}&app_absent=0`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  cursor: "pointer",
                  color: "#D0749B",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.textDecoration = "underline")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.textDecoration = "none")
                }
              >
                {row?.phone}
              </Typography>
            </TableCell>

            <TableCell align="right">
              <Typography color="text.secondary" fontWeight={400}>
                {row?.dni}
              </Typography>
            </TableCell>

            <TableCell>
              <Typography color="text.secondary" fontWeight={400}>
                {row?.user_location}
              </Typography>
            </TableCell>

            <TableCell>
              <Typography color="text.secondary" fontWeight={400}>
                {hasMembership ? (
                  <CheckIcon sx={{ color: "#28b06d" }} />
                ) : (
                  <CloseIcon sx={{ color: "#d96a70" }} />
                )}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography color="text.secondary" fontWeight={400}>
                {!row?.deleted ? (
                  <CheckIcon sx={{ color: "#28b06d" }} />
                ) : (
                  <CloseIcon sx={{ color: "#d96a70" }} />
                )}
              </Typography>
            </TableCell>




          </TableRow>
        );
      })}
    </TableBody>
  );
};

UserRows.propTypes = {
  rows: PropTypes.array.isRequired,
  isSelected: PropTypes.func.isRequired,
  onRowClick: PropTypes.func.isRequired,
  goToProfile: PropTypes.func.isRequired,
};

export default UserRows;
